import states from 'netc-states';

export default states.bootstrap().init();
